/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class TimePickerMinute extends React.Component {
    constructor(props) {
        super(props);

        this.getMinuteValues = this.getMinuteValues.bind(this);
        this.leadingZero = this.leadingZero.bind(this);
        this.changeHandler = this.changeHandler.bind(this);

    }

    getMinuteValues() {

        let start = 0,
            end = 60,
            ret = [];

        while (start < end) {
            ret.push(this.leadingZero(start));
            start++;
        }

        return ret;

    }

    leadingZero(val) {

        let ret = '' + val;

        if (ret < 10) {
            ret = '0' + ret;
        }

        return ret;

    }

    changeHandler(e) {

        let ret = e.currentTarget.value;

        e.preventDefault();

        this.props.changeHandler(ret, e);

    }

    shouldComponentUpdate(nextProps, nextState) {

        if (nextProps.scheduleTime !== undefined && (this.props.scheduleTime !== undefined && this.props.scheduleTime !== null)) {
            if (nextProps.scheduleTime.format('mm') == this.props.scheduleTime.format('mm')) {
                return false;
            }
        }

        return true;

    }

    render() {

        let time = moment(this.props.scheduleTime),
            minute = time.format('mm'),
            minutes = this.getMinuteValues(),
            minuteOptions = minutes.map((val, i) => {
                return (
                    <option value={val} key={'min-' + this.props.scheduleTime + '-' + val}>{val}</option>
                );
            });

        return (
            <select className="dlvr-select time-picker" value={minute} onChange={this.changeHandler} data-field="minutes">
                {minuteOptions}
            </select>
        );

    }

};

TimePickerMinute.displayName = "TimePickerMinute";

TimePickerMinute.propTypes = {
    scheduleTime: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    changeHandler: PropTypes.func
};

TimePickerMinute.defaultProps = {
    scheduleTime: moment().toISOString(),
    changeHandler: null
};

export default TimePickerMinute;
